import type {
  CottagePricesMediaItemsType,
  CottagePricesPhotoItemType,
} from '~~/modules/views/cottage-prices/entities/CottagePrices'
export const useCottageMedia = () => {
  const getPhotoItems = (
    item: CottagePricesMediaItemsType,
  ): CottagePricesPhotoItemType[] => {
    const returnSlides: CottagePricesPhotoItemType[] = []

    item.forEach(element => {
      if (element.type === 'PHOTO') {
        const photoItem: CottagePricesPhotoItemType = {
          url: element.url,
          type: element.type,
          alt: element.alt || '',
          width: element.width !== null ? element.width : 100,
          height: element.height !== null ? element.height : 100,
        }

        returnSlides.push(photoItem)
      }
    })

    return returnSlides
  }

  return { getPhotoItems }
}
